import create from "zustand"
import { devtools } from "zustand/middleware"
import queryString from "query-string"

const initialQueryString = queryString.parse(window.location.search)

export const parkingState = create(
  devtools((set) => ({
    ajaxSpinnerActive: false,
    ajaxSpinnerTransparent: false,
    airportCode: "CPH",
    allProducts: [],
    ammendmentEmail: "",
    ammendmentReference: "",
    arrivalDate: initialQueryString.ad || "",
    arrivalTime: initialQueryString.at || "17:30",
    billingAddress: {
      country: "Denmark",
      countryId: "293",
      email: "",
      firstName: "",
      lastName: "",
      mobilePhone: "",
      postcode: "",
      town: "",
    },
    bookingExtras: undefined,
    bookingExtrasConfiguration: undefined,
    bookingExtension: undefined,
    bookingResult: undefined,
    bookingUpsale: undefined,
    changeFromBooking: undefined,
    changeFromBookingGuid: undefined,
    checkoutErrors: {
      email: true,
      firstName: true,
      lastName: true,
      mobilePhone: true,
      postcode: true,
      showErrors: false,
      terms_and_condition: true,
      town: true,
    },
    consentContent: {},
    consentInformation: {
      ["Marketing Consent"]: false,
      ["Parking Consent"]: false,
      ["Terms and Conditions"]: false,
    },
    currentStep: 0,
    departureDate: initialQueryString.dd || "",
    departureTime: initialQueryString.dt || "17:30",
    durationDays: 0,
    error: null,
    locale: "",
    findBookingError: undefined,
    flightId: undefined,
    flightInformation: {
      inboundDate: undefined,
      inboundFlightNumber: undefined,
      outboundDate: undefined,
      outboundFlightNumber: undefined,
    },
    gaList: [],
    gaListIndex: 0,
    globals: {},
    hasLoadedUpgrade: false,
    hasQueryParameters: false,
    hasScrolled: false,
    isLoaded: false,
    isUpsold: undefined,
    leadTimeInHours: 1,
    loadingContactDetails: false,
    loadingFindBooking: false,
    loadingFindUpsaleForBooking: false,
    loadingFindUpsaleForBookingError: undefined,
    manageBookingResult: undefined,
    allConsentContent: {},
    parking: undefined,
    parkingHighlights: undefined,
    parkingProductId: undefined,
    paymentData: {},
    queryString: queryString.parse(window.location.search),
    receiptShouldTrack: false,
    reservationPlateLoader: false,
    selectedPaymentOption: [1],
    selectedPaymentType: {},
    setLoginStateAttempted: false,
    showMapInitially: false,
    showTooltip: false,
    tooltipData: null,
    upsaleTrackingData: {},
    useNewDesign: false,
    vehicleInformation: {
      vehicleColour: "",
      vehicleMake: "",
      vehicleModel: "",
      vehicleRegistrationNumber: "",
    },
    voucher: "",
    wantRefund: undefined,
    walletPaymentOptions: {},
    preventLoading: false,
    inputVoucher: "",
    affiliateCode: "",
    ad: "",
    adRaw: "",
    at: "",
    dd: "",
    ddRaw: "",
    dt: "",
    campaignCodePromptActive: true,
    today: new Date(),
    loadingFindExtrasForBooking: false,
    loadingFindExtrasForBookingError: undefined,
    isReceipt: false,
    currentFlow: "",
    absoluteMinDateTime: "",
    aMinTime: "",
    dMinTime: "",
    maxTime: "",
    minDate: "",

    // modals toggles
    isInModal: false,
    isParkingProductMapModalActive: false,
    isParkingMemberProductActive: false,
    isParkingSpecialProductActive: false,
    extraServiceModalProduct: undefined,
    extraServiceModalSelectorActive: false,
    extraServicesInfoModalActive: false,
    forgotReferenceModalActive: false,
    refundGuaranteeModalOpen: false,
    parkingTimeModalActive: false,
    isParkingDetailsModalActive: false,
    isParkingHighlightModalActive: false,
    paymentModalActive: false,
    genericModalActive: false,
    genericModalBody: "",
    genericModalCallback: null,

    // modal data
    refundGuaranteeModalData: { h3: "", richText: "" },
    parkingDetailsModalItem: undefined,
    latestHistoryForModal: undefined,
    modalOpenerId: "",

    // Actions to update state
    setField: (field, value) => set((state) => ({ ...state, [field]: value })),
    setInitialValues: (initialValues) => set({ ...initialValues }),
    updateBillingAddress: (address) => set((state) => ({ billingAddress: { ...state.billingAddress, ...address } })),
    updateCheckoutErrors: (errors) => set((state) => ({ checkoutErrors: { ...state.checkoutErrors, ...errors } })),
    updateFlightInfo: (info) => set((state) => ({ flightInformation: { ...state.flightInformation, ...info } })),
    updateVehicleInfo: (info) => set((state) => ({ vehicleInformation: { ...state.vehicleInformation, ...info } })),
    genericModalClose: (callback) => {
      set({ genericModalActive: false })
      if (callback) callback()
    },
    updateQueryStringState: () => {
      const newQueryString = queryString.parse(window.location.search)
      set((state) => ({
        queryParams: newQueryString,
        dd: newQueryString.dd || state.dd || "",
        dt: newQueryString.dt || state.dt || "10:00",
        ad: newQueryString.ad || state.ad || "",
        at: newQueryString.at || state.at || "17:30",
      }))
    },
  })),
  { name: "parkingState" },
)
